import React, { Component } from "react";

import { sendAPIRequest } from "shared/utils/requests";

class ChangeContractorUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
    };
  }

  handleEmailChange = (event) => {
    this.setState({email: event.target.value});
  };

  handleFormSubmit = (event) => {
    const { email } = this.state;
    event.preventDefault();

    sendAPIRequest(
      "/qa_super_user/change_contractor_user",
      "POST",
      {email},
    )
  };

  render() {
    const { email } = this.state;

    return (
      <form onSubmit={this.handleFormSubmit}>
        <div>
          email:
          <input value={email} onChange={this.handleEmailChange} />
        </div>

        <div><input type="submit" value="Switch to Contractor User" /></div>
      </form>
    );
  }
}

export default ChangeContractorUser;
